const SectionShell = ({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  children,
  className = '',
  bgClass = '',
}) => {
  const alignmentClass = align === 'center' ? 'text-center items-center' : 'text-left items-start';

  return (
    <section className={`w-full py-[60px] border-t border-[#EEEEEE] ${bgClass} ${className}`}>
      <div className="container-custom">
        <div className={`mb-10 flex flex-col gap-3 ${alignmentClass}`}>
          {eyebrow ? (
            <span className="inline-flex rounded-full border border-cyan-200 bg-cyan-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-cyan-700">
              {eyebrow}
            </span>
          ) : null}

          {title ? (
            <h2 className="relative max-w-full pb-4 font-semibold tracking-tight text-slate-900 text-3xl sm:text-4xl">
              {title}
              <span className={`absolute bottom-0 h-1 w-16 rounded-full bg-cyan-600 ${align === 'center' ? 'left-1/2 -translate-x-1/2' : 'left-0'}`} />
            </h2>
          ) : null}

          {subtitle ? (
            <p className="max-w-3xl text-base leading-relaxed text-slate-600 sm:text-lg">
              {subtitle}
            </p>
          ) : null}
        </div>

        {children}
      </div>
    </section>
  );
};

export default SectionShell;
